module.exports = __webpack_public_path__ + "84e488c6fc0d8b5fe5a82b584131547a.MP3";